<mat-card>
  <app-card-header
    [title]="'Tratar grupo'"
    [subtitle]="data.titulo"
    icono="checklist"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <mat-card-content class="card-content-crear">
      <p class="grupo-alcance">Se va a tratar {{ alcance }}</p>

      @if (truncado && !data.query) {
        <app-hint
          icon="warning"
          color="orange"
          message="El listado está truncado y este criterio de agrupación no se puede
            resolver en el servidor: sólo se tratan los eventos cargados."
        ></app-hint>
      }

      <!-- Estado -->
      <section class="inputs-group">
        <ng-select
          [items]="estados"
          formControlName="estado"
          placeholder="Estado"
          [clearable]="false"
          appendTo="body"
          notFoundText="Sin resultados"
          style="width: 100%"
        ></ng-select>
      </section>

      <!-- Mensaje -->
      <section class="inputs-group">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Mensaje</mat-label>
          <textarea
            matInput
            formControlName="nota"
            rows="4"
            placeholder="Qué se hizo con estos eventos"
          ></textarea>
          @if (form.get('nota')?.hasError('required')) {
            <mat-error>El mensaje es obligatorio</mat-error>
          }
        </mat-form-field>
      </section>

      <!-- Nota interna -->
      <section class="inputs-group">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nota interna (opcional)</mat-label>
          <textarea
            matInput
            formControlName="notaInterna"
            rows="2"
            placeholder="No la ve el cliente"
          ></textarea>
        </mat-form-field>
      </section>
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <button
        irxBoton="secundario"
        type="button"
        [disabled]="loading"
        (click)="cerrar()"
      >
        Cancelar
      </button>
      <button
        irxBoton="principal"
        type="submit"
        [disabled]="form.invalid || loading"
      >
        <mat-icon>troubleshoot</mat-icon>
        Tratar grupo
      </button>
    </mat-card-actions>
  </form>
</mat-card>
